// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"uT-z","inlineTitle":"vT-z","sponsoredAdsWrapper":"wT-z","marketplaceRecosWrapper":"xT-z","brandShopTheLookWrapper":"yT-z"};